import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Seen",
  "use": "Seen-usage",
  "viewBox": "0 0 20 13",
  "content": "<symbol viewBox=\"0 0 20 13\" id=\"Seen\"><g fill=\"currentColor\" fill-rule=\"nonzero\"><path d=\"M10 0C6.016 0 2.44 2.36 0 6.1c2.44 3.739 6.015 6.1 10 6.1 3.986 0 7.561-2.361 10-6.1C17.561 2.36 13.986 0 10 0zm0 9.912c-2.114 0-3.833-1.71-3.833-3.812s1.72-3.812 3.834-3.812c2.113 0 3.833 1.71 3.833 3.812s-1.72 3.812-3.833 3.812z\" /><path d=\"M9.8 3.75a2.296 2.296 0 0 0-2.3 2.287 2.296 2.296 0 0 0 2.3 2.288c1.267 0 2.3-1.027 2.3-2.288A2.296 2.296 0 0 0 9.8 3.75z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol